<template>
  <div class="add-guarantor-container">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>
  
<script>
import AddDefault from './AddNormal.vue'
import AddHeNan from './AddHeNan.vue'
export default {
  name: 'AddGuarantor',
  components: {
    AddDefault,
    AddHeNan
  },
  data() {
    return {
      layout: 'AddNormal',
      ready: false,
    };
  },
  mounted() {
    if (this.getConfig('ADD_GUARANTOR_MODE') !== 'HeNan') {
      this.layout = 'AddHeNan'
      this.ready = true
    } else {
      this.layout = 'AddNormal'
      this.ready = true
    }
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
  },
};
</script>
  
<style lang="less" scoped>

</style>
  